const wrapper = "cui-input-wrapper-hyjb";
const base = "cui-input-3cn0";
const warning = "cui-input-warning-4tal";
const prefix = "cui-input-prefix-0xal";
const suffix = "cui-input-suffix-0izk";
const inputClasses = {
  wrapper,
  base,
  warning,
  "align-right": "cui-input-align-right-srb3",
  "has-prefix": "cui-input-has-prefix-ontd",
  "has-suffix": "cui-input-has-suffix-gxeq",
  prefix,
  suffix
};
export {
  base,
  inputClasses as default,
  prefix,
  suffix,
  warning,
  wrapper
};
